export default __webpack_public_path__ + "static/media/image.suresh-madushan.a594f5cb.png";